import {
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { BsXLg } from "react-icons/bs";

type LoanModalProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  size?: string;
  title?: string;
};

export default function LoanApplicationModal(props: LoanModalProps) {
  const { title, isOpen, onClose, children, size = "md" } = props;
  return (
    <Modal 
      autoFocus={false} 
      isCentered 
      closeOnOverlayClick={false} 
      size={{ base: "full", sm: size }} 
      isOpen={isOpen} 
      onClose={onClose}
    >
      <ModalOverlay bg="#80808066" backdropFilter="blur(2px)" />
      <ModalContent 
        p={{ base: "4", md: "8", lg: "40px 64px" }} 
        borderColor="#E7ECFD" 
        borderRadius={{ base: "0", sm: "16px" }}
        margin={{ base: "0", sm: "1.75rem" }}
        maxH={{ base: "100vh", sm: "calc(100vh - 3.5rem)" }}
      >
        <Flex 
          justify="space-between" 
          flexDirection="row" 
          alignItems="center" 
          w="full" 
          mb={{ base: "4", md: "8" }}
        >
          <Text 
            fontWeight="900" 
            color="primary" 
            fontSize={{ base: "xl", md: "2xl" }}
            noOfLines={2}
            flex="1"
            mr="4"
          >
            {title}
          </Text>
          <Text 
            cursor="pointer" 
            onClick={onClose}
            p="2"
            fontSize={{ base: "lg", md: "xl" }}
            _hover={{ bg: "gray.100" }}
            borderRadius="md"
          >
            <BsXLg />
          </Text>
        </Flex>
        <Divider />
        <ModalBody pb={6} px="0" overflowY="auto">
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
